// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"618":"4a4dcfe5","970":"4a50f4d9"}[chunkId] + ".chunk.css";
};